import React, { useState, useEffect } from 'react';
import Cross from "../SmcLife/Images/crosssign.svg";
import MaskedInput from 'react-text-mask';
import { getAge, CalculateUserAge } from './UtilityComponents/UtilityFunction';

const PayForPopup = ({ Close, PeymentTermTillAge, OnSubmit, Data, UpdateValues }) => {
    const [paymentTerm, setPaymentTerm] = useState("");
    const [showCustomInput, setShowCustomInput] = useState(false);
    const paymentTermChangeHandler = (e) => {
        
        setShowCustomInput(false);
        if ((parseInt(Data.CoverTillAge) - CalculateUserAge(Data.DoB)) < parseInt(e.target.value)) {
        return alert("Payment Term can't be greater than policy term");
        }
        else {
        setPaymentTerm(e.target.value);
        }
        
    };

    useEffect(() => {
        let customInput = sessionStorage.getItem('cutomInputPayFor');
        if (customInput) {
            customInput = JSON.parse(customInput);
            setShowCustomInput(customInput);
        }
        
        setPaymentTerm(Data.PayTerm === 1 ? 'One time payment' : Data.PayTerm === Data?.PolicyTerm ? "Till policy term" : Data.PayTerm);
    }, []);

    const handleSubmit = (e) => {
        const payTerm = paymentTerm === 'One time payment' ? 1 : paymentTerm === "Till policy term" ? Data?.PolicyTerm : paymentTerm;
      //  console.log("age", CalculateUserAge(Data.DoB))
        const age = CalculateUserAge(Data.DoB);
        const coverTillAge = parseInt(Data.CoverTillAge);
        if ((coverTillAge-age) < parseInt(payTerm)) {
            return alert("Payment Term can't be greater than policy term");
        } else {
            if (showCustomInput) {
                sessionStorage.setItem('cutomInputPayFor', true);
            } else {
                sessionStorage.removeItem('cutomInputPayFor');
            }
            if (paymentTerm === 'One time payment') {
                UpdateValues("S");
            }
            OnSubmit(payTerm);
            Close();
        }
    };


    return (
        <div className="">
            <div className="pay_for">
                <div className="payment_forPOP">
                    <div>
                        <div className="CrossSign" onClick={Close}>
                            <h5>Select Payment Term</h5>
                            <img src={Cross} alt="Benefits&Riders" />
                        </div>
                        <hr className="mt-1" />
                        <div className="payment_term">
                            {Data.PolicyTerm >= 5 && <label className="peyment_opt peyment_optFirst4">
                                <input
                                    type="radio"
                                    name="paymentTerm"
                                    value="5"
                                    checked={paymentTerm === "5"}
                                    onChange={paymentTermChangeHandler}
                                />
                                <span>5 years</span>
                            </label>}
                            {Data.PolicyTerm >= 10 && <label className="peyment_opt peyment_optFirst4">
                                <input
                                    type="radio"
                                    name="paymentTerm"
                                    value="10"
                                    checked={paymentTerm === "10"}
                                    onChange={paymentTermChangeHandler}
                                />
                                <span>10 years</span>
                            </label>}
                            {Data.PolicyTerm >= 15 && <label className="peyment_opt peyment_optFirst4">
                                <input
                                    type="radio"
                                    name="paymentTerm"
                                    value="15"
                                    checked={paymentTerm === "15"}
                                    onChange={paymentTermChangeHandler}
                                />
                                <span>15 years</span>
                            </label>}
                            {Data.PolicyTerm >= 20 && <label className="peyment_opt peyment_optFirst4 right_align">
                                <input
                                    type="radio"
                                    name="paymentTerm"
                                    value="20"
                                    checked={paymentTerm === "20"}
                                    onChange={paymentTermChangeHandler}
                                />
                                <span>20 years</span>
                            </label>}
                            {Data.PolicyTerm >= (60 - getAge(Data?.DoB)) && <label className="peyment_opt peyment_optLast4">
                                <input
                                    type="radio"
                                    name="paymentTerm"
                                    value={60 - getAge(Data?.DoB)}
                                    checked={paymentTerm == (60 - getAge(Data?.DoB))}
                                    onChange={paymentTermChangeHandler}
                                />
                                <span>Pay till 60 ({60 - getAge(Data?.DoB)} years)</span>
                            </label>}
                            <label className="peyment_opt peyment_optLast4">
                                <input
                                    type="radio"
                                    name="paymentTerm"
                                    value="One time payment"
                                    checked={paymentTerm === "One time payment"}
                                    onChange={paymentTermChangeHandler}
                                />
                                <span>One time payment</span>
                            </label>

                           

                            {Data.PolicyTerm != 5 && <label className="peyment_opt peyment_optLast4">
                                <input
                                    type="radio"
                                    name="paymentTerm"
                                    checked={showCustomInput === true}
                                    onChange={() => { setShowCustomInput(true); setPaymentTerm(''); }}
                                />
                                <span>Select custom term</span>
                            </label>}

                            {Data.PolicyTerm != 5 && <label className="peyment_opt peyment_optLast4">
                                <input
                                    type="radio"
                                    name="paymentTerm"
                                    value="Till policy term"
                                    checked={paymentTerm === "Till policy term"}
                                    onChange={paymentTermChangeHandler}
                                />
                                <span>Till policy term ({Data?.PolicyTerm} years)</span>
                            </label>}
                           
                            {showCustomInput && Data.PolicyTerm != 5 && (<>
                                <div className="select_years">
                                    <div className="user-input-wrp">
                                        <MaskedInput
                                            className="inputText"
                                            mask={[
                                                /[0-9]/,
                                                /[0-9]/,
                                            ]}
                                            guide={false}
                                            required
                                            autoFocus
                                            showMask={false}
                                            value={paymentTerm}
                                            onChange={(e)=> setPaymentTerm(e.target.value)}
                                        />
                                        <span className="floating-label">Enter Years</span>
                                    </div>
                                <span>min 5 years & max {Data.PolicyTerm} years</span>
                                </div>
                            </>
                            )}
                        </div>
                        <div className="submit_btn_payFor">
                            <button className="FormGetTouch2" disabled={!paymentTerm} onClick={handleSubmit}>Submit</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default PayForPopup;
